import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classes from './styles.module.scss';
import Loader from '../../Loader/Loader';
import { ReactComponent as PlusIcon } from '../../../../assets/icons/plus.svg';
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit.svg';
import { ReactComponent as PrintIcon } from '../../../../assets/icons/print.svg';
import { ReactComponent as AddPostIcon } from '../../../../assets/icons/chatPlus.svg';
import { ReactComponent as ScheduleIcon } from '../../../../assets/icons/schedule_ready.svg';
import { ReactComponent as LockIcon } from '../../../../assets/icons/lock.svg';
import { ReactComponent as CopayIcon } from '../../../../assets/icons/co-pay.svg';
import { ReactComponent as ReversalIcon } from '../../../../assets/icons/reversal.svg';
import { ReactComponent as TransferIcon } from '../../../../assets/icons/transfer.svg';
import { ReactComponent as ProcessIcon } from '../../../../assets/icons/process_ready.svg';
import { ReactComponent as ApproveIcon } from '../../../../assets/icons/approve.svg';
import { ReactComponent as DeniedIcon } from '../../../../assets/icons/denied.svg';
import { ReactComponent as DistributionIcon } from '../../../../assets/icons/distribution.svg';
import { ReactComponent as ReviewIcon } from '../../../../assets/icons/review_flag.svg';
import { ReactComponent as FillIcon } from '../../../../assets/icons/fill.svg';
import { ReactComponent as SignIcon } from '../../../../assets/icons/sign.svg';
import { ReactComponent as ReceiveIcon } from '../../../../assets/icons/receive.svg';
import { ReactComponent as UnlockIcon } from '../../../../assets/icons/unlock.svg';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/download.svg';
import { ReactComponent as ImportIcon } from '../../../../assets/icons/import.svg';
import { ReactComponent as AssignIcon } from '../../../../assets/icons/assign.svg';
import { ReactComponent as SendIcon } from '../../../../assets/icons/send.svg';

function Button({
  title = '', type = 'button', className = '', btnClassName = '', href = '', buttonColor = '#547EEE',
  loading, disabled, clearButton, reverseColor, addButton, editButton, unlockButton, printButton, addPostButton,
  scheduleButton, authorizationButton, copayButton, reversalButton, receiveButton, transferButton, processButton,
  approveButton, deniedButton, distributionButton, reviewButton, fillButton, signButton, importButton, downloadButton,
  sendButton, assignButton, onClick = () => {},
}) {
  const btnWrapperCls = [classes.btn_wrapper, className];
  const btnCls = [classes.btn, btnClassName];

  if (clearButton) btnWrapperCls.push(classes.clear_button);
  if (printButton) btnWrapperCls.push(classes.print_button);

  if (scheduleButton || authorizationButton || copayButton || reversalButton || transferButton
   || processButton || approveButton || deniedButton || distributionButton || reviewButton || fillButton
    || signButton || receiveButton) {
    btnWrapperCls.push(classes.schedule_button);
  }

  if (reverseColor) btnWrapperCls.push(classes.reverse_color);
  if (disabled) btnWrapperCls.push(classes.disabled);

  const Component = href ? NavLink : 'button';

  return (
    <div className={btnWrapperCls.join(' ')}>
      <Component
        type={type}
        to={href}
        onClick={onClick}
        className={btnCls.join(' ')}
        disabled={loading || disabled}
        style={{
          '--button-color': `${buttonColor}`,
        }}
      >
        <span className={classes.title_wrapper}>
          {loading
            ? (
              <Loader
                className={classes.btn_loading}
                size={24}
              />
            )

            : (
              <>
                {addButton && <PlusIcon className={classes.add_button_svg} />}
                {editButton && <EditIcon className={classes.edit_button_svg} />}
                {printButton && <PrintIcon />}
                {addPostButton && <AddPostIcon className={classes.chat_plus_button_svg} />}
                {scheduleButton && <ScheduleIcon />}
                {authorizationButton && <LockIcon />}
                {copayButton && <CopayIcon />}
                {reversalButton && <ReversalIcon />}
                {transferButton && <TransferIcon />}
                {processButton && <ProcessIcon />}
                {approveButton && <ApproveIcon />}
                {deniedButton && <DeniedIcon />}
                {distributionButton && <DistributionIcon />}
                {reviewButton && <ReviewIcon />}
                {fillButton && <FillIcon />}
                {signButton && <SignIcon />}
                {receiveButton && <ReceiveIcon />}
                {importButton && <ImportIcon className={classes.unlock_button_svg} />}
                {unlockButton && <UnlockIcon className={classes.unlock_button_svg} />}
                {downloadButton && <DownloadIcon className={classes.add_button_svg} />}
                {sendButton && <SendIcon className={classes.send_button_svg} />}
                {assignButton && <AssignIcon className={classes.add_button_svg} />}

                {title}
              </>
            )}
        </span>
      </Component>
    </div>
  );
}

Button.propTypes = {
  title: PropTypes.any,
  type: PropTypes.oneOf(['button', 'submit']),
  className: PropTypes.string,
  btnClassName: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  clearButton: PropTypes.bool,
  addButton: PropTypes.bool,
  editButton: PropTypes.bool,
  unlockButton: PropTypes.bool,
  printButton: PropTypes.bool,
  reverseColor: PropTypes.bool,
  addPostButton: PropTypes.bool,
  scheduleButton: PropTypes.bool,
  authorizationButton: PropTypes.bool,
  copayButton: PropTypes.bool,
  reversalButton: PropTypes.bool,
  receiveButton: PropTypes.bool,
  transferButton: PropTypes.bool,
  processButton: PropTypes.bool,
  approveButton: PropTypes.bool,
  deniedButton: PropTypes.bool,
  distributionButton: PropTypes.bool,
  fillButton: PropTypes.bool,
  reviewButton: PropTypes.bool,
  assignButton: PropTypes.bool,
  signButton: PropTypes.bool,
  downloadButton: PropTypes.bool,
  importButton: PropTypes.bool,
  sendButton: PropTypes.bool,
  onClick: PropTypes.func,
  buttonColor: PropTypes.string,
  href: PropTypes.string,
};

export default Button;
